var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.564 16.1c.294 0 .527-.13.69-.382l6.46-10.172c.124-.198.172-.349.172-.506 0-.376-.246-.622-.622-.622-.274 0-.424.089-.588.349l-6.139 9.782-3.185-4.17c-.171-.24-.342-.335-.588-.335-.39 0-.657.266-.657.643a.83.83 0 00.199.498l3.548 4.52c.205.266.417.396.71.396z"
  })));
}

export default SvgCheckmark;